/* eslint-disable */
import React from 'react';
import { Button, Alert } from 'react-bootstrap';

class ToolStatus extends React.Component {
  constructor(props) {
    super(props);
    this.state = { showLog: false };
  }

  toggleLog = () => {
    this.setState({ showLog: !this.state.showLog });
  };

  render() {
    return (
      <Alert variant={this.props.status}>
        <h4>{this.props.status === 'success' ? 'Success' : 'Sorry'}!</h4>
        <p>{this.props.status === 'success' ? this.props.subheading : 'Something went wrong'}</p>
        {this.state.showLog && (
          <pre className="gopherLog">{this.props.message}</pre>
        )}
        <Button variant="link" onClick={this.toggleLog}>
          {this.state.showLog ? 'hide' : 'view'} log
        </Button>
      </Alert>
    );
  }
}

export default ToolStatus;
